// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1311":"5643de18","7295":"6e2af107"}[chunkId] + ".chunk.css";
};